export default {
  locationFinder: {
    mapOptions: {
      userPosition: {
        lat: 38.930045,
        lng: -94.673355
      },
      zoomRadius: 48280.3,
      markerIcon: {
        url: "/img/template-images/map-pin.png",
        labelOrigin: {
          x: 16,
          y: 18
        }
      },
      markerLabel: {
        color: "#ffffff",
        fontFamily: "Gotham SSm A, Gotham SSm B, Arial, sans-serif",
        fontSize: "14px",
        fontWeight: "500"
      }
    },
    geolocateUser: true,
    totalLocations: 11,
    locationsPerPage: 5,
    zipCodeLat: 0,
    zipCodeLng: 0,
    locations: [
      {
        title: "Ferrellgas Kansas City",
        name: "Kansas City KS - SU",
        contactEmail: "KarlWinbigler@ferrellgas.com",
        address: {
          street: "2837 Roe Lane",
          city: "Kansas City",
          state: "KS",
          zipCode: "66103-1542"
        },
        phoneNumber: "913-236-5656",
        url:"/propane-locations/ks/kansas-city/roe-lane/293900/",
        coordinates: { lat: 39.049877166748, lng: -94.6413650512695 },
        hasHours: true,
        hoursMessage: "",
        hours: [
          { day: "Mo", hours: ["08:00 - 17:00"] },
          { day: "Tu", hours: ["08:00 - 17:00"] },
          { day: "We", hours: ["08:00 - 17:00"] },
          { day: "Th", hours: ["08:00 - 17:00"] },
          { day: "Fr", hours: ["08:00 - 17:00"] },
          { day: "Sa", hours: [""] },
          { day: "Su", hours: [""] }
        ],
        hasTankExchangeService: true,
        hasServiceRefuelingStation: true
      },
      {
        title: "Ferrellgas Gardner",
        name: "Gardner KS",
        contactEmail: "ChadBurns@ferrellgas.com",
        address: {
          street: "109 Prairie Village Dr",
          city: "Gardner",
          state: "KS",
          zipCode: "66030"
        },
        phoneNumber: "913-856-6287",
        url: "/locations/detail/gardner-ks/291340",
        coordinates: { lat: 38.8147048950195, lng: -94.9274444580078 },
        hasHours: false,
        hoursMessage:
          "While no customer service personnel are available at this location, our best-in-class Ferrellgas drivers still stop at this location to fill their delivery trucks before making deliveries to you and your neighbors.",
        hours: [],
        hasTankExchangeService: false,
        hasServiceRefuelingStation: false
      },
      {
        title: "Ferrellgas Kansas City",
        name: "Chouteau MO",
        contactEmail: "MattByram@ferrellgas.com",
        address: {
          street: "1775 NE Chouteau Trafficway",
          city: "Kansas City",
          state: "MO",
          zipCode: "64120-1009"
        },
        phoneNumber: "913-236-5656",
        url: "/locations/detail/kansas-city-mo/293910",
        coordinates: { lat: 39.1393775939941, lng: -94.5300445556641 },
        hasHours: true,
        hoursMessage: "",
        hours: [
          { day: "Mo", hours: ["07:00 - 15:30"] },
          { day: "Tu", hours: ["07:00 - 15:30"] },
          { day: "We", hours: ["07:00 - 15:30"] },
          { day: "Th", hours: ["07:00 - 15:30"] },
          { day: "Fr", hours: ["07:00 - 15:30"] },
          { day: "Sa", hours: [""] },
          { day: "Su", hours: [""] }
        ],
        hasTankExchangeService: true,
        hasServiceRefuelingStation: true
      },
      {
        title: "Ferrellgas Tonganoxie",
        name: "Tonganoxie KS",
        contactEmail: "ChadBurns@ferrellgas.com",
        address: {
          street: "1208 State Ave, Ste B",
          city: "Tonganoxie",
          state: "KS",
          zipCode: "66086-9706"
        },
        phoneNumber: "913-845-0037",
        url: "/locations/detail/tonganoxie-ks/291310",
        coordinates: { lat: 39.1158, lng: -95.07448 },
        hasHours: false,
        hoursMessage:
          "While no customer service personnel are available at this location, our best-in-class Ferrellgas drivers still stop at this location to fill their delivery trucks before making deliveries to you and your neighbors.",
        hours: [],
        hasTankExchangeService: false,
        hasServiceRefuelingStation: false
      },
      {
        title: "Ferrellgas Harrisonville",
        name: "Harrisonville MO",
        contactEmail: "KarlWinbigler@ferrellgas.com",
        address: {
          street: "27019 South Brookhart Drive",
          city: "Harrisonville",
          state: "MO",
          zipCode: "64701-6355"
        },
        phoneNumber: "816-884-4721",
        url: "/locations/detail/harrisonville-mo/254100",
        coordinates: { lat: 38.625623, lng: -94.35201 },
        hasHours: false,
        hoursMessage:
          "While no customer service personnel are available at this location, our best-in-class Ferrellgas drivers still stop at this location to fill their delivery trucks before making deliveries to you and your neighbors.",
        hours: [],
        hasTankExchangeService: false,
        hasServiceRefuelingStation: false
      }
    ]
  }
};
